import React from "react";
import PropTypes from "prop-types";
import { FiCheck } from "react-icons/fi";
import useTranslation from "next-translate/useTranslation";

import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";
import { Container } from "./styles";

const BundleFeatures = ({ features }) => {
  const { lang } = useTranslation();

  return (
    <Container>
      {features?.map((feature) => (
        <div key={feature.id} className="feature">
          <div className="icon-container">
            <FiCheck size={23} color="#1cb800" />
          </div>

          <p>{staticIntlTranslatorToString(feature.name, lang)}</p>
        </div>
      ))}
    </Container>
  );
};

BundleFeatures.propTypes = {
  features: PropTypes.array.isRequired,
};

export default BundleFeatures;
